<template>
  <div class="content-wrapper d-lg-block" :class="{'d-none': isMobileMenuOpen}">
    <mobile-top @close-mobile-menu="close_mobile_menu"></mobile-top>

    <div class="updates">
      <ul>
        <li class="update"
            v-for="(report, index) in reports"
            v-bind:key="index"

        >
        <div :class="[
                'overlay-content-off',
                {'active': isHidden[index]}
               ]"
          >
            <b-row class="top-part">
              <b-col>
                <small>
                  <time-ago :refresh="30" :long="true" :datetime="report.publish_date" />
                </small>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="8" sm="9" lg="12" xl="9">
                <p v-html="report.content"></p>

              </b-col>
              <b-col>
                <a :href="report.pdf_report" target="_blank" v-if="check_for_subscription() && report.pdf_report" @click="trigger_google_analytics_event(report.id)">
                  <img src="/img/pdf.svg" alt="PDF" width="50px">
                </a>

                <a href="#" @click="open_subscribe_popup()" v-if="!check_for_subscription()">
                  <img src="/img/pdf.svg" alt="PDF" width="50px">
                </a>
              </b-col>
            </b-row>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MobileTop from '../market/MobileTop.vue'
import { event } from 'vue-gtag'

export default {
  props: ['isMobileMenuOpen'],
  data () {
    return {
      isFilterClosed: true,
      isInstradaySingleClose: true,
      intraday_update_chart_active_id: '',
      isHidden: [],
      constants: {
        max_intraday_number_of_graphs: 2,
        max_intraday_text_length: 450
      },
      search: '',
      filter_options: [
        {
          id: 1,
          name: 'Primary Markets'
        },
        {
          id: 2,
          name: 'Other Updates/Markets'
        },
        {
          id: 3,
          name: 'Trading notes'
        }
      ],
      market: null
    }
  },
  components: {
    MobileTop
    // BaseCheckbox
  },
  mounted () {
    this.market = this.$route.matched[0].meta.market

    this.$store.dispatch('reports/loadReports')

    this.$cable.subscribe({
      channel: 'ReportChannel'
    })
  },
  computed: {
    ...mapState({
      reports: state => state.reports.reports,
      current_user: state => state.profile.account.current_user,
      popup_visibility: state => state.subscribe_popup.popup_visibility
    }),
    updates_bar () {
      const filtered_updates = this.updates.filter(
        update => update.markets?.some(
          market => market === this.market
        ) || update.instruments?.some(
          instrument => instrument.markets.includes(this.market)
        ) || update.markets?.some(
          market => market.slug === this.market
        )
      )

      filtered_updates.sort((a, b) => new Date(b.sortable_date) - new Date(a.sortable_date))

      if (this.search === '') {
        return filtered_updates
      }

      return filtered_updates.filter(
        update => update.linked_instruments?.some(
          linked_instrument => linked_instrument.name.toLowerCase().includes(this.search.toLowerCase())
        ) ||
          update.content?.toLowerCase().search(this.search.toLowerCase()) > -1
      )
    },
    toggle_show_charts_updates: {
      get () {
        return this.show_charts_updates
      },
      set (show_charts_updates) {
        this.$store.dispatch('updates/update_show_charts_updates', show_charts_updates)
      }
    }
  },
  methods: {
    ...mapActions({
      open_popup: 'subscribe_popup/open_popup'
    }),
    close_mobile_menu () {
      this.$emit('close-mobile-menu')
    },
    toggle_intraday_updates_filter () {
      this.isFilterClosed = !this.isFilterClosed
    },
    save_changes () {
      this.$notify({
        text: this.$t('components.intraday_updates.successfully_updated')
      })
    },
    intraday_update_list_toggle (index) {
      this.$set(this.isHidden, index, !this.isHidden[index])
    },
    comma_to_list (text, list_length, index) {
      if (index !== list_length) {
        return text + ', '
      }

      return text
    },
    check_for_subscription () {
      if (this.current_user.open_door && this.current_user.open_door_accessed) {
        return true
      }

      const market_subscription = this.current_user.subscriptions.filter(
        s => s.markets.some(
          m => m.slug === this.market
        )
      ).length

      return !(this.current_user.subscriptions.length === 0 || market_subscription === 0)
    },
    open_subscribe_popup () {
      this.open_popup()
    },
    show_intraday_single (intraday_update_id, chart_id) {
      this.intraday_update_chart_active_id = chart_id

      const modal_id = 'intraday_single_' + intraday_update_id
      this.$refs[modal_id][0].show(intraday_update_id)
    },
    scroll_to (element) {
      this.$scrollTo(element, 500, { container: '.content', offset: -60 })
    },
    trigger_google_analytics_event (report_id) {
      event('report_download', {
        event_category: 'US Stocks Reports',
        event_label: `Report ID: ${report_id}`
      })
    }
  },
  channels: {
    ReportChannel: {
      received (data) {
        this.$store.dispatch('reports/load_report_from_cable', { report: JSON.parse(data) })
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
